/*
 *		Copyright (c) 2011-2014 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

'use strict';

angular.module('access.Nodes')
    .factory('LinksInterceptor', ['LinkBuilder', function(LinkBuilder){
        return {
            response: function(response) {
                var links = [];

                if(angular.isArray(response.resource)) {
                    angular.forEach(response.resource, function(entry){
                        links.push(new LinkBuilder(entry).buildFromLink());
                    });
                    return links;
                } else {
                    return new LinkBuilder(response.resource).buildFromLink();
                }
            }
        };
    }]);
